<template>
  <div class="loader-container">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>
</template>

<script>

export default {
  name: 'loader'
}
</script>

<style lang="sass">
$loaderColor: #438EF0

.loader-container
  width: 100%
  height: 100%
  padding-left: calc(50% - 40px)

.lds-ring
  display: inline-block
  position: relative
  width: 80px
  height: 80px
  div
    box-sizing: border-box
    display: block
    position: absolute
    width: 64px
    height: 64px
    margin: 8px
    border: 8px solid $loaderColor
    border-radius: 50%
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite
    border-color: $loaderColor transparent transparent transparent
    &:nth-child(1)
      animation-delay: -0.45s

    &:nth-child(2)
      animation-delay: -0.3s

    &:nth-child(3)
      animation-delay: -0.15s
@keyframes lds-ring
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>